import React, { Component,useEffect,useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config.js'
// import { toast } from 'react-toastify';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';

const ExitProcedure = () => {
 const [data, setData] = useState({ exit_types: [] });
  const [exitType, setExitType] = useState("");
  const [data1, setData1] = useState([]);
  const [reason, setReason] = useState('');
  const [answers, setAnswers] = useState({});
  const [cnt, setCnt] = useState(null);
   const [error, setError] = useState(null);

  const [titles, setTitles] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const token = localStorage.getItem('authToken');


  const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage,setEntriesPerPage]=useState(10);
    let filteredItems = data1.filter((item) =>
  
  
  
      `${item.employee_id.toLowerCase()}${item.employee_name.toLowerCase()}${item.department_name.toLowerCase()}`.includes(searchTerm.toLowerCase())
  
    );
    const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
    const indexOfLast = currentPage * entriesPerPage;
    const indexOfFirst = indexOfLast - entriesPerPage;
    const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);
  
    const startIndex = (currentPage - 1) * entriesPerPage;
  
  
    useEffect(() => {
      setCurrentPage(1);
    }, [searchTerm]);
  
    // const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
    const handleSearch = (event) => {
      setSearchTerm(event.target.value);
    };
  
  
    const clearInput = () => {
      setSearchTerm("");
      };
  


  useEffect(()=> {
    axios.get(API_BASE_URL +'/get_exittype', {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    })
  
    // .then(res =>console.log(res.data))
     .then(res => setData(res.data))
    .catch(err => console.log(err));
  },[]);

  // useEffect(() => {
  //   axios.get(`${API_BASE_URL}/get_exitprocedure`, {
  //     headers: { Authorization: `Bearer ${token}` }
  //   }).then(res => setData1(res.data));
  // }, []);



  useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get(API_BASE_URL + "/getInterviewAnswerscnt", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        },
      });
      // console.log(response.data);
      
      setCnt(response.data);
      // console.log("Exit Procedures Count:", cnt.exitProceduresCount);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);



const handleExitSubmit = async (e) => {

	e.preventDefault();
   

	// setError(null);
	// setLoading(true);
	// e.preventDefault();
	axios.post(API_BASE_URL+'/addExitProcedure', { exittype: exitType, reason: reason}, {
					headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
				}).then(response => {
		// 	console.log(response.data);
		// 	console.log(response.data.message);
		// })

		var status = response.data.status;
		
		if (status == 200) {
			toast.success(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",

			});


			const timeout = setTimeout(() => {
				window.location.href = "exitprocedure";
				// window.location.reload(); // Reload the current page
			}, 5000); // Refresh after 5 seconds

			return () => {
				clearTimeout(timeout); // Cleanup the timeout if the component unmounts
			};

		} else if(status == 401) {
			toast.error(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",

			});
		}
		else if (status == 400) {
			toast.error(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",

			});
		}


	}).catch(error => {
		// console.log('error');
		 console.log("ERROR RESPONSE FULL:", error.response.data.message);
  // console.log("ERROR RESPONSE DATA:", error.response?.data);
  // console.log("ERROR ERRORS:", error.response?.data?.errors);




		toast.error(error.response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",


		});

	});
};



useEffect(() => {
		axios.get(API_BASE_URL + '/exit_procedure_list', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then(res => setData1(res.data))
			// .then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])



//   const [titles, setTitles] = useState([]);
    const [singleQuestions, setSingleQuestions] = useState([]);
    const [formData, setFormData] = useState({});

    // useEffect(() => {
    //     loadData();
    // }, []);

	useEffect(() => {
    const loadData = async () => {
        const res = await axios.get(`${API_BASE_URL}/get_questions`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
        });

        setTitles(res.data.titles);
        setSingleQuestions(res.data.single_questions);


        
    };

    loadData();   // <-- IMPORTANT: CALL IT HERE
}, []);

    const handleChange = (titleId, questionId, value) => {
        setFormData(prev => ({
            ...prev,
            [`${titleId}_${questionId}`]: value
        }));
    };

const handleSubmit = async (e) => {
    e.preventDefault();

    try {
        console.log("FORM SUBMIT:", formData);

        const response = await axios.post(
            `${API_BASE_URL}/submit_interview_answers`,
            { answers: formData },
            { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
        );

        const status = response.data.status;

        if (status === 200) {

            toast.success(response.data.message, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });

            setTimeout(() => {
                window.location.href = "exitprocedure";
            }, 5000);
        }

        else if (status === 401) {
            toast.error(response.data.message, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }

    } catch (error) {
        console.error(error);
        toast.error("Failed to save interview answers!");
    }
};




useEffect(() => {
  const defaultForm = {};

  // For singleQuestions (answertype 2)
  singleQuestions.forEach((sq) => {
    if (sq.answertype === 2) {
      defaultForm[`single_${sq.ques_id}`] = "excellent"; // default
    }
  });

  // For normal questions (answertype 2)
  titles.forEach((title) => {
    title.questions.forEach((q) => {
      if (q.answertype === 2) {
        defaultForm[`${title.id}_${q.id}`] = "excellent"; // default
      }
    });
  });

  setFormData(defaultForm);
}, [singleQuestions, titles]);





  return (
    <div className="container mt-3">
    <ToastContainer/>

    
     

      {/* Exit Procedure Form */}
      <form onSubmit={handleExitSubmit} className="mb-4">

        <div className="col-lg-12 col-md-12">
<div className="card" >
<div className="card-body">
<div className="row clearfix"></div>
 <h5>Exit Procedure</h5>
       <div className="col-lg-3 col-md-4">
          <label>Exit Type</label>
            <select
      className="form-control"
      value={exitType}
      onChange={(e) => setExitType(e.target.value)}
     
    >
      <option value="">Select Exit Type</option>
      {data.exit_types.map((type) => (
        <option key={type.id} value={type.id}>
          {type.exit_type}
        </option>
      ))}
    </select>
        </div><br/>

        <div className="col-lg-6 col-md-6">
          <label>Reason</label>
          <textarea
            className="form-control"
            rows="4"
            value={reason}
            onChange={(e) => setReason(e.target.value)}

          ></textarea>
        </div>
        </div><br/>

     <div className="col-lg-4 col-md-4">
  <div className="form-group">
    {cnt?.exitProceduresCount === 0  && (
      <button type="submit" className="btn btn-round btn-primary">
        Save
      </button>
    )}
  </div>
</div>


        {/* {!data.exit_procedure && <button className="btn btn-primary">Save</button>} */}

        

        </div>

</div>




      </form>

{cnt ? (
  // --- CASE 1: Interview already submitted ---
  cnt.answers_count > 0 ? (
    <div className="col-lg-12 col-md-12">
      <div className="card">
        <div className="card-body">
          <p style={{ color: "green", fontSize: "18px", fontWeight: "bold" }}>
            Interview form submitted successfully
          </p>
        </div>
      </div>
    </div>
  ) : 


 cnt && cnt.answers_count === 0 && cnt.exit_count > 0 && new Date(cnt.current_date) >= new Date(cnt.nodue_date) ? (
	 <form onSubmit={handleSubmit}>
            <h3>Interview Questions</h3>

            {titles.map((title, t) => (
                <div className="card mb-4" key={title.id}>
                    <h6 className="card-header">{title.title_name}</h6>
                    <div className="card-body">
                        <table className="table table-bordered">
                            <tbody>
                                {title.questions.map((q, i) => (
                                    <tr key={q.id}>
                                        <td width="60%">{q.question}</td>
                                        <td width="40%">
                                            {/* Radio Yes/No */}
                                            {q.answertype === 1 && (
                                                <>
                                                    <input
                                                        type="radio"
                                                        name={`ans_${title.id}_${q.id}`}
                                                        value="yes"
                                                        required
                                                        onChange={() => handleChange(title.id, q.id, "yes")}
                                                        
                                                    /> Yes

                                                    <input
                                                        type="radio"
                                                        name={`ans_${title.id}_${q.id}`}
                                                        value="no"
                                                        required
                                                        onChange={() => handleChange(title.id, q.id, "no")}
                                                    /> No
                                                </>
                                            )}

                                            {/* Checkbox Multi Option */}


                                            {q.answertype === 2 && (
  <>
    {["excellent", "good", "fair", "poor"].map((option) => (
      <label key={option} className="mr-2">
        <input
          type="checkbox"
          checked={formData[`${title.id}_${q.id}`] === option} // only one checked
          onChange={() =>
            setFormData((prev) => ({
              ...prev,
              [`${title.id}_${q.id}`]: option, // overwrite previous
            }))
          }
        />{" "}
        {option.charAt(0).toUpperCase() + option.slice(1)}
      </label>
    ))}
  </>
)}

                                            {/* {q.answertype === 2 && (
                                                <>
                                                    <label className="mr-2">
                                                        <input
                                                            type="checkbox"
                                                            onChange={() => handleChange(title.id, q.id, "excellent")}
                                                        /> Excellent
                                                    </label>

                                                    <label className="mr-2">
                                                        <input
                                                            type="checkbox"
                                                            onChange={() => handleChange(title.id, q.id, "good")}
                                                        /> Good
                                                    </label>

                                                    <label className="mr-2">
                                                        <input
                                                            type="checkbox"
                                                            onChange={() => handleChange(title.id, q.id, "fair")}
                                                        /> Fair
                                                    </label>

                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            onChange={() => handleChange(title.id, q.id, "poor")}
                                                        /> Poor
                                                    </label>
                                                </>
                                            )} */}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ))}

            {/* SINGLE QUESTIONS */}
            <div className="card mb-4">
                <h6 className="card-header">Additional Questions</h6>
                <div className="card-body">
                    <table className="table table-bordered">
                        <tbody>
                            {singleQuestions.map((sq, i) => (
                                <tr key={sq.ques_id}>
                                    <td width="60%">{sq.questions}</td>

                                    <td width="40%">
                                        {sq.answertype === 1 && (
                                            <>
                                                <input
                                                    type="radio"
                                                    name={`single_${sq.ques_id}`}
                                                    value="yes"
                                                    onChange={() => handleChange("single", sq.ques_id, "yes")}
                                                    required
                                                /> Yes
                                                <input
                                                    type="radio"
                                                    name={`single_${sq.ques_id}`}
                                                    value="no"
                                                    onChange={() => handleChange("single", sq.ques_id, "no")}
                                                /> No
                                            </>
                                        )}


                                        {sq.answertype === 2 && (
  <>
    {["excellent", "good", "fair", "poor"].map((option) => (
      <label key={option} className="mr-2">
        <input
          type="checkbox"
          checked={formData[`single_${sq.ques_id}`] === option}
          onChange={() =>
            setFormData((prev) => ({
              ...prev,
              [`single_${sq.ques_id}`]: option,
            }))
          }
        />{" "}
        {option.charAt(0).toUpperCase() + option.slice(1)}
      </label>
    ))}
  </>
)}


                                        {/* {sq.answertype === 2 && (
                                            <>
                                                <input type="checkbox" onChange={() => handleChange("single", sq.ques_id, "excellent")} /> Excellent
                                                <input type="checkbox" onChange={() => handleChange("single", sq.ques_id, "good")} /> Good
                                                <input type="checkbox" onChange={() => handleChange("single", sq.ques_id, "fair")} /> Fair
                                                <input type="checkbox" onChange={() => handleChange("single", sq.ques_id, "poor")} /> Poor
                                            </>
                                        )} */}

                                        {sq.answertype === 3 && (
                                            <textarea
                                                rows="3"
                                                className="form-control"
                                                onChange={(e) =>
                                                    handleChange("single", sq.ques_id, e.target.value)
                                                }
                                                required
                                            ></textarea>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <button className="btn btn-primary">Submit</button>
        </form>
) : (
      // --- CASE 3: Not Eligible ---
      <div className="col-lg-12 col-md-12">
        <div className="card">
          <div className="card-body">
            <p style={{ color: "red", fontSize: "18px", fontWeight: "bold" }}>
              You are not eligible to fill the interview form at this time.
            </p>
          </div>
        </div>
      </div>
    )
) : null}

      {/* Interview Questions Section */}
      {/* {data.current_date >= data.nodue_date && (
        <form onSubmit={handleAnswerSubmit}>
          <h5>Interview Questions</h5>
          {data.interview_titles.map((title, idx) => (
            <div key={idx} className="card mb-3 p-3">
              <h6>{title.question_title}</h6>
              {title.questions.map((q, i) => (
                <div key={i} className="mt-2">
                  <label>{q.questions}</label>
                  {q.answertype === 1 && (
                    <>
                      <div>
                        <label><input type="radio" name={`q${q.id}`} value="yes" onChange={() => setAnswers({...answers, [q.id]: 'yes'})}/> Yes</label>
                        <label className="ms-3"><input type="radio" name={`q${q.id}`} value="no" onChange={() => setAnswers({...answers, [q.id]: 'no'})}/> No</label>
                      </div>
                    </>
                  )}
                  {q.answertype === 2 && (
                    <select className="form-control" onChange={(e) => setAnswers({...answers, [q.id]: e.target.value})}>
                      <option>Excellent</option>
                      <option>Good</option>
                      <option>Fair</option>
                      <option>Poor</option>
                    </select>
                  )}
                  {q.answertype === 3 && (
                    <textarea className="form-control" onChange={(e) => setAnswers({...answers, [q.id]: e.target.value})}></textarea>
                  )}
                </div>
              ))}
            </div>
          ))}
          <button className="btn btn-success">Submit Answers</button>
        </form>
      )} */}

    <div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
															
                              <th>Employee ID</th>
															<th>Employee</th>
															<th>Department</th>
															<th>Applied On</th>
															<th>Incharge</th>
															<th>Hod</th>
															<th>HR</th>
														</tr>
													</thead>
													<tbody>



														{
															filteredData.map((exitpdr, index) => {

																return <tr key={index}>
																	
																	
																	<td>
																		<span>{exitpdr.employee_id}</span>
																	</td>
																	<td>
																		<span>{exitpdr.employee_name}</span>
																	</td>
																	<td>
																		<span>{exitpdr.department_name}</span>
																	</td>

																	<td>
																		<span>{exitpdr.applied_on}</span>
																	</td>

																	<td>
																		<span>{ReactHtmlParser(exitpdr.incharge_status)}</span>
																	</td>


																	<td>
																		<span>{ReactHtmlParser(exitpdr.hod_status)}</span>
																	</td>

																	<td>
																		<span>{ReactHtmlParser(exitpdr.hr_status)}</span>
																	</td>

																	
																</tr>


															})
														}

													</tbody>
												</table>
											</div>



											<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>	

                      </div>




    </div>
  );
};

export default ExitProcedure;
